module.exports = __webpack_public_path__ + "static/media/durotype-flexosoft-light.d07a242c.otf";